<template>
  <div id="numbers" :class="cls">
    <div class="text-center">
      <h2>{{ this.message(this.$appdata.messages, "numbers").label }}</h2>
      <b-progress :max="max" variant="info" height="3em">
        <b-progress-bar :value="value" :label="reviewing"></b-progress-bar>
      </b-progress>
    </div>
  </div>
</template>
<script>
import { compStyles } from "@/mixins/compStyles";
import { messaging } from "@/mixins/messaging";
import { navigation } from "@/mixins/navigation";
export default {
  props: [
    "active_key",
    "age",
    "dob",
    "death_benefit",
    "health_bracket",
    "health_bracket_str",
    "issues",
    "estimate",
    "is_candidate",
    "active_index",
  ],
  mixins: [messaging, compStyles, navigation],
  data() {
    return {
      disp_key: 4,
      cls: "component out",
      value: 0,
      max: 100,
      progress: 0,
      reviewing: "",
    };
  },
  methods: {
    run: function () {
      // If the user has hit the back/previous button, clear the timeouts
      if (this.$appdata.seq.length > 0) {
        this.$appdata.seq.forEach((item) => {
          clearTimeout(item);
        });
        this.$appdata.seq = [];
        this.decNext();
      } else {
        var t = this;

        this.$appdata.seq.push(
          setTimeout(() => {
            t.value = 12;
            t.reviewing = "Age";
          }, t.$appdata.timeouts.age)
        );

        this.$appdata.seq.push(
          setTimeout(() => {
            t.value = 42;
            t.reviewing = "Policy";
          }, t.$appdata.timeouts.policy)
        );

        this.$appdata.seq.push(
          setTimeout(() => {
            t.value = 76;
            t.reviewing = "Health";
          }, t.$appdata.timeouts.health)
        );

        if (t.issues.length > 0) {
          this.$appdata.seq.push(
            setTimeout(() => {
              t.value = 81;
              t.reviewing = "Health Issues";
            }, t.$appdata.timeouts.issues)
          );
        }

        this.$appdata.seq.push(
          setTimeout(() => {
            t.value = 100;
            t.reviewing = "Complete";
          }, t.$appdata.timeouts.complete)
        );

        this.$appdata.seq.push(
          setTimeout(() => {
            t.$emit("setProp", { prop: "active_key", value: 5 });
          }, t.$appdata.timeouts.next)
        );
      }
    },
  },
  watch: {
    active_key: function (n) {
      this.toggleActive(n);
      // Route to qualified, unqualified page
      if (this.active_key == this.disp_key) {
        // Set the info we've gathered to a cookie we can use with the web to lead form.
        var cand = {
          age: this.age,
          dob: this.dob,
          death_benefit: this.death_benefit,
          health_bracket: this.health_bracket,
          health_bracket_str: this.health_bracket_str,
          issues: this.issues,
          estimate: this.estimate,
          is_candidate: this.is_candidate,
        };

        cand = JSON.stringify(cand);
        cand = btoa(cand);

        this.$cookie.set(this.$appdata.ck_name, cand, 1);

        if (this.health_bracket == "" || this.health_bracket < 1) {
          this.$router.go();
        } else {
          this.run();
        }
      }
    },
  },
};
</script>
<style lang="scss">
.progress {
  .bg-info {
    font-size: 1.5em;
    background: #993774 !important;
  }
}
</style>
